import React from 'react';
import type { Candidate } from '@axiom/validation';
import {
  Badge,
  Card,
  CardSection,
  Gutter,
  Paragraph,
  Layout,
  Well,
  useApi,
  Brief,
} from '@axiom/ui';

import { ProfileCompletionUtil } from '../../utils/profile-completion-util';
import { CandidateProfileIssuesApi } from '../../api/candidate-profile-issues-api';
import { CandidateExperienceApi } from '../../api/candidate-experience-api';

import { ActionNeededListItem } from './ActionNeededListItem';

export type ActionNeededListProps = {
  candidate: Candidate;
};

export const ActionNeededList = ({ candidate }: ActionNeededListProps) => {
  const [{ data: profileIssues }, { data: experiences }] = useApi(
    CandidateProfileIssuesApi.readCandidateProfileIssues(candidate.id),
    CandidateExperienceApi.readExperiences(candidate.id)
  );

  const actionNeededItems = ProfileCompletionUtil.getActionNeededItems(
    profileIssues.issues,
    experiences,
    candidate.degrees
  );

  return actionNeededItems.length > 0 ? (
    <Card>
      <CardSection background="blue">
        <Badge background="red">Action Needed</Badge>
        <Gutter bottom="16px" />
        <Paragraph>
          Your profile is how clients decide whether they want to engage you,
          and it’s how Axiom finds you to recommend you to clients. Here’s what
          you need to do to get your profile completed, and get the kind of work
          you want faster.
        </Paragraph>
        <Gutter bottom="24px" />
        <Well background="light">
          <Brief
            name="REQUIRED_COMPLETION_STEPS_BRIEF"
            briefMaxHeight="320px"
            position="center"
          >
            <Layout
              name="required-completion-steps"
              direction="vertical"
              verticalGutter="16px"
            >
              {actionNeededItems.map(item => (
                <ActionNeededListItem key={item.name} actionItem={item} />
              ))}
            </Layout>
          </Brief>
        </Well>
      </CardSection>
    </Card>
  ) : null;
};
